var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c_loading"},[_c('van-loading',{staticClass:"c-loading-content",attrs:{"color":"#F9436B"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }